import * as types from '../mutation-types'
import {cleanToken, loginS} from '../../api/api'
import md5 from 'crypto-js/md5'
import {storejs} from '../../common/js/util'
import {cellLogin, loginByUserNameV1, loginInfo} from '../../api/apiLoginVerify'

const state = {
  userInfo: null,
  token: storejs.get(process.env.APPKEY + 'token')
}

// getters
const getters = {
  token: state => state.token,

  userInfo: (state, getters) => {
    let userInfo = state.userInfo
    if (userInfo && !userInfo.imageUrl) {
      userInfo.imageUrl = 'http://7xpvo0.com2.z0.glb.qiniucdn.com/user/GetUserImage.jpeg'
    }
    return userInfo
  }
}

// actions
const actions = {
  userLogin({commit}, {username, password}) {
    return new Promise((resolve, reject) => {
      var loginObj = {
        success: true,
        msg: '登录成功'
      }
      loginS({username: username, password: md5(password)}).then((response) => {
        let {data} = response
        if (data.userInfo != null && data.token != null) {
          commit(types.UPDATE_TOKEN, data.token)
          commit(types.UPDATE_USER_INFO, data.userInfo)
          resolve(loginObj)
        } else {
          loginObj.success = false
          loginObj.msg = response.data.msg
          resolve(loginObj)
        }
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  //账号登录增加校验
  userLoginAccount({commit, dispatch}, formdata) {
    return new Promise((resolve, reject) => {
      var loginObj = {
        success: true,
        msg: '登录成功'
      }
      // loginByUserNameV1 accoutLogin
      loginByUserNameV1(formdata)
      .then(async (response) => {
        let data = {
          token: response.data
        }
        if (data.token) {
          //updatetoken
          commit(types.UPDATE_TOKEN, data.token)
          await dispatch('userInfo')
          loginObj.userInfo = state.userInfo
          resolve(loginObj)
        } else {
          loginObj.success = false
          loginObj.msg = response.msg
          resolve(loginObj)
        }
      })
      .catch(function (error) {
        reject(error)
      })
    })
  },
  //短信登录
  userLoginCell({commit, dispatch}, formdata) {
    return new Promise((resolve, reject) => {
      const loginObj = {
        success: true,
        msg: '登录成功'
      }
      cellLogin(formdata)
      .then(async (response) => {
        let data = {
          token: response.data
        }
        if (data.token) {
          //updatetoken
          commit(types.UPDATE_TOKEN, data.token)
          await dispatch('userInfo')
          resolve(loginObj)
        } else {
          loginObj.success = false
          loginObj.msg = response.msg
          resolve(loginObj)
        }
      })
      .catch(function (error) {
        reject(error)
      })
    })
  },
  auth_jwt({dispatch, commit}) {
    return new Promise((resolve, reject) => {
      loginInfo()
      .then((res) => {
        let {code, data} = res;
        if (code !== 0) {
          dispatch("userLogout");
          reject();
        }
        commit(types.UPDATE_USER_INFO, data);
        resolve();
      })
      .catch(function (error) {
        dispatch("userLogout");
        reject(error);
      });
      // authJWT().then(response => {
      //   let {data} = response
      //   if (response.status == 200 && data.isAuthenticated) {
      //     commit(types.UPDATE_USER_INFO, data.userInfo)
      //     resolve()
      //   } else {
      //     dispatch('userLogout')
      //     reject()
      //   }
      // }).catch(function (error) {
      //   dispatch('userLogout')
      //   reject()
      // })
    })
  },
  userLogout({commit}) {
    cleanToken()
    storejs.remove(process.env.APPKEY + 'token')
    commit(types.UPDATE_USER_INFO, null)
    commit(types.UPDATE_TOKEN, '')
  },
  /**
   * @description: 用户信息
   */
  async userInfo({commit}) {
    let userInfo = await loginInfo()
    commit(types.UPDATE_USER_INFO, userInfo.data)
  },
  /**
   * @description: 获取用户信息
   */
  getUserInfo({commit}) {
    return new Promise(async (resolve) => {
      let userInfo = await loginInfo()
      commit(types.UPDATE_USER_INFO, userInfo.data)
      resolve(userInfo.data)
    })
  }
}

// mutations
const mutations = {
  [types.UPDATE_USER_INFO](state, userInfo) {
    state.userInfo = userInfo
  },
  [types.UPDATE_TOKEN](state, token) {
    storejs.set(process.env.APPKEY + 'token', token)
    state.token = token
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js